import React from "react";
import PropTypes from "prop-types";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Style from "./datepicker.module.scss";
import { dMMMyyyy } from "../../utils/constants/appConstants";
import { handleDateChange, handleRawDateChange } from "../../utils/dateUtils";
const DatePicker = ({ value, onChange, ...rest }) => {
  return (
    <div
      className={`${Style.modalDatePickerContainer} ${rest.disabled ? Style.disabled : ""}`}
    >
      <ReactDatePicker
        className={Style.datepicercustom}
        selected={value}
        onChange={(date) => {
          if (onChange) handleDateChange(date, onChange);
        }}
        onChangeRaw={(event) =>
          handleRawDateChange({
            event,
            onChange,
            validateRange: false
          })
        }
        dateFormat={dMMMyyyy}
        popperPlacement="bottom"
        popperClassName={Style.datePickerPopper}
        portalId="root"
        {...rest}
      />
    </div>
  );
};

DatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default DatePicker;
